"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_helmet_1 = __importDefault(require("react-helmet"));
const Select_1 = __importDefault(require("@Components/Selectors/Select"));
const Button_1 = require("@Components/Buttons/Button");
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const mobx_react_1 = require("mobx-react");
const Sidebar_1 = require("@Components/Sidebars/Sidebar");
const contexts_1 = require("@App/contexts");
const statements_1 = require("@App/api/routes/rightsholder/statements");
const ContentHeader_1 = __importDefault(require("@Components/ContentHeader"));
const react_1 = require("react");
const RoyaltiesAnnualStatementsTable_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderRoyaltiesAnnualStatements/RoyaltiesAnnualStatementsTable"));
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const RightsholderRoyaltiesAnnualStatements = () => {
    const { statementsStore, rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [sidebarIsOpen, setSidebarIsOpen] = (0, react_1.useState)(false);
    const [usagePeriod, setUsagePeriod] = (0, react_1.useState)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const onUsagePeriodChange = (newUsagePeriod) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        setUsagePeriod(newUsagePeriod);
        yield statementsStore.loadRoyalties(newUsagePeriod.value);
        setLoading(false);
    });
    const sendTSVRequest = (payeeId) => __awaiter(void 0, void 0, void 0, function* () {
        if (usagePeriod) {
            setSidebarIsOpen(true);
            const rhId = rightsholderStore.currentRightsholderId;
            yield (0, statements_1.createAnnualTsvRequest)(rhId, { payee: payeeId.toString(), year: usagePeriod.value });
        }
    });
    const usagePeriodOptions = () => [2021, 2022, 2023]
        .map((year, index) => ({
        label: year.toString(),
        value: year.toString(),
        id: (index + 1).toString(),
    }))
        .reverse();
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('rightsholder_annual_statements');
        setLoading(true);
        statementsStore.clearRoyalties();
        onUsagePeriodChange(usagePeriodOptions()[0]).then();
        return () => {
            statementsStore.clearRoyalties();
        };
    }, []);
    const usagePeriodOptionsArray = usagePeriodOptions();
    return (React.createElement(React.Fragment, null,
        React.createElement(react_helmet_1.default, { title: 'Royalty Statements' }),
        React.createElement("div", { className: "royalties-wrapper" },
            React.createElement("div", { className: 'global-container' },
                React.createElement(ContentHeader_1.default, { title: 'Annual Statements of Account', descriptionElement: React.createElement("div", null,
                        React.createElement("p", null, "An annual statement is a comprehensive report of royalties for a given year."),
                        React.createElement("p", null, "Select the year you wish to review in the drop-down menu. Once the information populates, you can download the annual statement in the Statement column.")) }),
                React.createElement("div", { className: 'filter-block' },
                    React.createElement("div", { className: 'filters-row' },
                        React.createElement("div", { className: 'filter-item-wrapper' },
                            React.createElement("div", { className: 'filter-item' },
                                React.createElement("p", { className: 'small bold' }, "Selected year:"),
                                React.createElement(Select_1.default, { options: usagePeriodOptionsArray, selectedValue: usagePeriod, defaultValue: usagePeriodOptionsArray[0], onValueChange: onUsagePeriodChange }))))),
                loading ? React.createElement(PointPreloader_1.default, null) : React.createElement(RoyaltiesAnnualStatementsTable_1.default, { sendTSVRequest: sendTSVRequest }))),
        React.createElement(ModalPortal_1.default, { isOpen: sidebarIsOpen, onClose: () => setSidebarIsOpen(false) },
            React.createElement(Sidebar_1.Sidebar, { onClose: () => setSidebarIsOpen(false) },
                React.createElement("div", { className: "download-sidebar" },
                    React.createElement("h2", null, "Your files are on the way!"),
                    React.createElement("p", { className: 'large' }, "We're preparing your files for download. You'll receive an email shortly with downloadable statements."),
                    React.createElement("div", { className: 'download-button' },
                        React.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: () => setSidebarIsOpen(false) }, "Done")))))));
};
exports.default = (0, mobx_react_1.observer)(RightsholderRoyaltiesAnnualStatements);
